<template>
  <div class="route-schedule mt-5">
    <div class="flex justify-between mb-4">
      <p class="text-base font-semibold">Route Schedule</p>
      <p
        style="white-space: nowrap"
        class="text-primary-yellow font-semibold cursor-pointer flex gap-2"
        @click="
          editOperation = false;
          edittSchedule = {};
          isRouteScheduleModal = true;
        "
      >
        <img src="@/assets/images/icons/add.svg" alt="add icon" />
        Add Information
      </p>
    </div>
    <div class="flex flex-row gap-5 text-sm">
      <label class="label my-auto">Shipment collection cut-off time </label>
     
      <tooltip
      class="my-auto"
        text="Set the cut-off time to collect new shipments meant for this service. Any shipment received after the cut-off time will ship with the next service."
      >
        <span>
         <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.8 5.6H7.2V4H8.8V5.6ZM8.8 12H7.2V7.2H8.8V12ZM8 0C6.94943 0 5.90914 0.206926 4.93853 0.608964C3.96793 1.011 3.08601 1.60028 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.08601 14.3997 3.96793 14.989 4.93853 15.391C5.90914 15.7931 6.94943 16 8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 6.94943 15.7931 5.90914 15.391 4.93853C14.989 3.96793 14.3997 3.08601 13.6569 2.34315C12.914 1.60028 12.0321 1.011 11.0615 0.608964C10.0909 0.206926 9.05058 0 8 0Z"
              fill="#383F51"
            />
          </svg>
        </span>
      </tooltip>
      <el-select
        class="my-auto"
        style="width: 126px"
        filterable
        placeholder="Select"
      >
        <el-option
          v-for="location in locations"
          :key="location.id"
          :label="location.locationName"
          value="location.id"
        >
        </el-option>
      </el-select>
      <span class="my-auto">Hours Prior</span>
    </div>

    <table class="custom-table responsive-table">
      <thead>
        <tr class="shadow-table rounded-lg">
          <th colspan="4">Forward Trip ({{ forward }} to {{ backward }})</th>
          <th colspan="1"><span class="border"></span></th>
          <th colspan="4">Return Trip ({{ backward }} to {{ forward }})</th>
        </tr>
      </thead>
      <thead>
        <tr class="shadow-table _2ndth rounded-lg">
          <td>Day</td>
          <td>Time</td>
          <td>SST</td>
          <td>Express Delivery</td>
          <td colspan="1"><span class="border"></span></td>

          <td>Day</td>
          <td>Time</td>
          <td>SST</td>
          <td>Express Delivery</td>
          <td></td>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(schedule, index) in schedules"
          :key="index"
          class="shadow-table rounded-lg"
        >
          <td>{{ schedule.day == null ? "" : schedule.day }}</td>
          <td>{{ schedule.time == null ? "" : schedule.time }}</td>
          <td>{{ schedule.sst == null ? "" : schedule.sst }}</td>
          <td>{{ schedule.express == null ? "" : schedule.express }}</td>
          <td colspan="1"><span class="border"></span></td>
          <td>{{ schedule.returnday == null ? "" : schedule.returnday }}</td>
          <td>{{ schedule.returntime == null ? "" : schedule.returntime }}</td>
          <td>{{ schedule.returnsst == null ? "" : schedule.returnsst }}</td>
          <td>
            {{ schedule.returnexpress == null ? "" : schedule.returnexpress }}
          </td>
          <td @click="setIndex(index)">
            <el-dropdown
              trigger="click"
              placement="top"
              @command="performAction"
            >
              <vertical-ellipsis />
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="edit">
                  <button class="flex flex-nowrap w-full p-1 text-left">
                    <p class="">Edit</p>
                  </button>
                </el-dropdown-item>
                <el-dropdown-item command="delete">
                  <button class="flex flex-nowrap w-full p-1 text-left">
                    <p class="">Delete</p>
                  </button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </td>
        </tr>
      </tbody>
    </table>

    <route-schedule-modal
      :showModal="isRouteScheduleModal"
      @close-modal="
        isRouteScheduleModal = false;
        editOperation = false;
      "
      @create-schedule="createSchedule"
      :editOperation="editOperation"
      :editSchedule="edittSchedule"
    />
  </div>
</template>

<script>
import RouteScheduleModal from "./modals/RouteScheduleModal";
import Tooltip from "@/components/UI/Tooltip.vue";

export default {
  components: {
    RouteScheduleModal,
    Tooltip
  },
  props: {
    routeSchedules: {
      type: Array,
    },
    forward: {
      type: String,
    },
    backward: {
      type: String,
    },
  },
  data() {
    return {
      isRouteScheduleModal: false,
      scheduleIndex: -1,
      schedules: [],
      editOperation: false,
      edittSchedule: {},
    };
  },
  watch: {},
  mounted() {
    this.schedules = this.routeSchedules;
  },
  methods: {
    performAction(action) {
      if (action == "edit") {
        this.editSchedule(this.scheduleIndex);
      } else if (action == "delete") {
        this.deleteSchedule(this.scheduleIndex);
      }
    },
    setIndex(index) {
      this.scheduleIndex = index;
    },
    saveRouteSchedule(schedule) {
      this.$emit("update-route-schedule", schedule);
    },
    createSchedule(schedule, edit) {
      if (edit) {
        this.schedules[this.scheduleIndex] = schedule;
      } else {
        this.schedules.push(schedule);
      }

      this.$emit("update-route-schedule", this.schedules);
    },
    deleteSchedule(index) {
      this.schedules.splice(index);
    },

    editSchedule(index) {
      this.scheduleIndex = index;
      this.editOperation = true;

      this.edittSchedule = this.schedules[this.scheduleIndex];

      this.isRouteScheduleModal = true;
    },
    resetFields() {
      this.routeSchedules = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.update-text {
  color: #f57a4d;
  font-weight: bold;
  cursor: pointer;
}
.custom-table {
  margin-top: 0.5rem;
}
// thead tr {
//   border-top: 1px solid #d5d5d5;
// }
_2ndth {
  color: #7a90a7;
}
</style>
